<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4">
      <v-card class="elevation-12">
        <validation-observer v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(submit)">
            <v-toolbar dark flat>
              <v-toolbar-title>GODCS</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <validation-provider
                :vid="uuid()"
                name="Email"
                rules="required|email"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Email"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="user.email"
                ></v-text-field>
                <span class="validation-message">{{ errors[0] }}</span>
              </validation-provider>
              <validation-provider
                :vid="uuid()"
                name="Passowrd"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="user.password"
                ></v-text-field>
                <span class="validation-message">{{ errors[0] }}</span>
              </validation-provider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="dark" text type="submit">Login</v-btn>
            </v-card-actions>
          </form>
        </validation-observer>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import uuid from "src/mixins/uuid";
import validationRules from "src/mixins/validationRules";
import http from "src/util/http";

export default {
  name: "Login",
  components: { ValidationProvider, ValidationObserver },
  mixins: [uuid, validationRules],
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
    };
  },
  mounted() {
    localStorage.removeItem("authen-token");
  },
  methods: {
    async submit() {
      const response = await http().post("login", this.user);

      localStorage.setItem("authen-token", response.data.token);
      localStorage.setItem("role", response.data.role);
      localStorage.setItem("userId", response.data.userId);
      localStorage.setItem("email", response.data.email);
      this.$router.push({ name: "Project" });
    },
  },
};
</script>
